<template>
  <div
          style=" width: 100%; height: 100%; position: absolute;background-color: white;overflow: auto; "
  >


    <div style="position: fixed;background: rgba(0, 0, 0, .075);width: 100%;height: 100%;z-index: 999" v-if="isLoading">
      <a-spin style="transform:translate(-50%,-50%);position: absolute;top: 50%; left: 50%;"/>
    </div>

    <el-container class="container">
      <div>
        <el-row style="display: flex; justify-content: center;">
          <el-col :xs="0" :sm="3" :lg="3"></el-col>
          <el-col
                  :xs="24"
                  :sm="20"
                  :lg="20"
                  style=" display: flex; justify-content: center;"
          >
            <el-row style="display: flex; align-items: center;width: 100%;">
              <el-col  style="width: 250px;line-height: 18px;">
                <p style="font-size: 16px;margin: 0;">快递单号</p>
                <p style="font-size: 15px;margin: 0;white-space: nowrap;">Tracking Number</p>
              </el-col>


              <el-col  style="margin-right: 5px;margin-left: 5px;">

                <el-input
                        placeholder="请输入快递单号"
                        v-model="userForm.trackingNumber"
                        @keyup.enter="queryOrder"
                >

                  <el-button slot="append"  @click="handleBarcode"  v-if="isHiddenScan" >
                    <a-icon style="font-size: 18px" type="scan" />
                  </el-button>


                </el-input>


              </el-col>



              <el-col :xs="4" :sm="8" :lg="7"
              ><el-button type="primary" @click="queryOrder" style="padding: 6px 10px;">
                <p style="margin: 0;">查询</p>
                <p style="margin: 0;">Search</p>
              </el-button></el-col
              >
            </el-row>
          </el-col>
          <!-- :sm="10" :md="8" :lg="8" -->
          <el-col :xs="1" :sm="1" :lg="1"></el-col>
        </el-row>
      </div>

      <br/>
      <h2 style="font-size: 30px;">个人信息：</h2>
      <h2 style="font-size: 18px;">Personal Information</h2>
      <br/>

      <el-header style="height: auto;margin-bottom: 30px">
        <el-row style=" display: flex; justify-content: left;height: 50px;">
          <el-col style="width: 300px">
            <span class="required">*</span>用户名：
            <span style="font-size: 18px;position: absolute;top: 16px;left: 10px;">Name</span>
          </el-col>
          <el-col  >{{userForm.userName}}</el-col>
        </el-row>



        <el-row style="display: flex; justify-content: left;height: 50px;">
          <el-col style="width: 300px"  ><span class="required">*</span>电话：
            <span style="font-size: 18px;position: absolute;top: 16px;left: 10px;">Phone Number</span>
          </el-col>
          <el-col >{{userForm.phone}}</el-col>
        </el-row>



        <el-row style="display: flex; justify-content: left;min-height: 50px;">
          <el-col  style="width: 300px"><span class="required">*</span>地址：
            <span style="font-size: 18px;position: absolute;top: 16px;left: 10px;">Address</span>
          </el-col>
          <el-col
          >{{userForm.address}}</el-col
          >
        </el-row>
      </el-header>


      <h2 style="font-size: 30px;">洗护前照片：</h2>
      <h2 style="font-size: 18px;">The Product Image before Laundry Service</h2>
      <br/>

      <el-main style="flex: none;">
        <el-row style="display: flex; justify-content: center;">
          <el-col style="text-align: center;">
            <el-upload
                    :auto-upload="false"
                    class="upload-demo"
                    ref="uploadPicRef"
                    action=""
                    list-type="picture-card"
                    :on-change="beforeUploadPic"
                    :on-success="uploadPicSuccess"
                    :on-remove="removePic"
                    :data="uploadData"
                    :limit="4"
                    :file-list="picFileList"
                    :show-file-list="true"
                    :on-preview="handlePictureCardPreview"
            >
              <i
                      class="el-icon-plus"
                      style="font-size: 60px;color: deepskyblue;margin: 20px;"
              ></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :span="6" width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-col>
        </el-row>
      </el-main>

      <br/>
      <h2 style="font-size: 30px;">洗护后照片：</h2>
      <h2 style="font-size: 18px;">The Product Image after Laundry Service</h2>
      <br/>

      <el-footer class="el-footer" style="height: auto; padding: 0;">
        <!-- 洗护后照片 -->
        <el-row style="display: flex; justify-content: center;">
          <el-col style="text-align: center;">
            <el-upload
                    :auto-upload="false"
                    class="upload-demo"
                    ref="uploadPicRef"
                    action=""
                    list-type="picture-card"
                    :on-change="beforeUploadPic2"
                    :on-success="uploadPicSuccess2"
                    :on-remove="removePic2"
                    :data="uploadData2"
                    :limit="4"
                    :file-list="picFileList2"
                    :show-file-list="true"
                    :on-preview="handlePictureCardPreview2"
            >
              <i
                      class="el-icon-plus"
                      style="font-size: 60px;color: deepskyblue;margin: 20px;"
              ></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible2">
              <img :span="6" width="100%" :src="dialogImageUrl2" alt="" />
            </el-dialog>
          </el-col>
        </el-row>

        <el-row class="flex-align">
          <!--          <el-col :xs="1" :sm="2" :lg="3"></el-col>-->

          <el-col style="max-width: 500px;" >
            <!-- 上标题 -->
            <el-row class="flex-align">
              <el-col :span="3">
                <div class="flex-div">
                  <div class="flex-position-left  flex-position-right flex-position-bottom flex-text-align">
                    <p class="span-font-size " :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">下单 </p>
                    <p class="span-font-size " :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">Release order </p>
                  </div>
                </div>
              </el-col>

              <el-col class="flex-text-align" :span="4"></el-col>

              <el-col :span="3">
                <div class="flex-div">
                  <div
                          class="flex-position-left  flex-position-right flex-position-bottom flex-text-align"
                  >
                    <p class="span-font-size" :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">同意</p>
                    <p class="span-font-size" :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">Approval</p>
                  </div>
                </div>
              </el-col>

              <el-col style="text-align: center;" :span="4"></el-col>

              <el-col :span="3">
                <div class="flex-div">
                  <div
                          class="flex-position-left  flex-position-right flex-position-bottom flex-text-align"
                  >
                    <p class="span-font-size " :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">运输</p>
                    <p class="span-font-size " :style="userForm.status >= '00'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">Shipping</p>
                  </div>
                </div>
              </el-col>

              <el-col style="text-align: center;" :span="4"></el-col>

              <el-col :span="3">
                <div class="flex-div">
                  <div
                          class="flex-position-left  flex-position-right flex-position-bottom flex-text-align"
                  >
                    <p class="span-font-size " :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">签收入库</p>
                    <p class="span-font-size " :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">Receiving</p>
                  </div>
                </div>
              </el-col>

              <!--              <el-col style="text-align: center;" :span="3"></el-col>-->

              <!--              <el-col :span="2">-->
              <!--                <div class="flex-div">-->
              <!--                  <div-->
              <!--                    class="flex-position-left  flex-position-right flex-position-bottom flex-text-align"-->
              <!--                  >-->
              <!--                    <p class="span-font-size" :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">洗护前质检</p>-->
              <!--                    <p class="span-font-size" :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">Quality Check before Washing<p/>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </el-col>-->
            </el-row>

            <!-- 上步骤条 -->
            <el-row class="flex-align">
              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius"
                          :style="userForm.status >= '00'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="4" class="flex-align flex-height">
                <div style=" width: 100%;height: 5px; position: relative; ">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "
                          :style="userForm.status >= '00'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '00'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <div style=" width: 100%;  position: relative; height: 5px;">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "
                          :style="userForm.status >= '00'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div
                        style=" width: 100%; padding-top: 100%; border-radius: 50%; position: relative;"
                >
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius"
                          :style="userForm.status >= '00'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <div style=" width: 100%;  position: relative;    height: 5px;">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "
                          :style="userForm.status >= '00'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '40'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <!--              <el-col :span="3">-->
              <!--                <div style=" width: 100%;  position: relative;    height: 5px;">-->
              <!--                  <div-->
              <!--                    class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "-->
              <!--                      :style="userForm.status >= '40'  ? 'background-color: orange' : 'background-color: #ccc' "-->
              <!--                  ></div>-->
              <!--                </div>-->
              <!--              </el-col>-->

              <!--              <el-col :span="2">-->
              <!--                <div-->
              <!--                  style=" width: 100%; padding-top: 100%; border-radius: 50%; position: relative;"-->
              <!--                >-->
              <!--                  <div-->
              <!--                    class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius"-->
              <!--                    :style="userForm.status >= '40'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "-->
              <!--                  ></div>-->
              <!--                </div>-->
              <!--              </el-col>-->
            </el-row>

            <!-- 竖线 -->
            <el-row class="flex-align">
              <el-col
                      style="font-size: 8px;text-align: center;"
                      :span="3"
              ></el-col>
              <el-col
                      style=" font-size: 8px;text-align: center;"
                      :span="4"
              ></el-col>
              <el-col
                      style="font-size: 8px;text-align: center;"
                      :span="3"
              ></el-col>
              <el-col
                      style="font-size: 8px;text-align: center;"
                      :span="4"
              ></el-col>
              <el-col
                      style="font-size: 8px;text-align: center;"
                      :span="3"
              ></el-col>
              <el-col
                      style=" font-size: 8px;text-align: center;"
                      :span="4"
              ></el-col>
              <!--              <el-col-->
              <!--                style="font-size: 8px;text-align: center;"-->
              <!--                :span="2"-->
              <!--              ></el-col>-->
              <!--              <el-col-->
              <!--                style="font-size: 8px;text-align: center;"-->
              <!--                :span="5"-->
              <!--              ></el-col>-->
              <el-col :span="3" class="center-line-col" >
                <div class="vertical-line"   :style="userForm.status >= '50'  ? 'border-left: 5px solid orange;' : 'border-left: 5px solid #ccc;' " ></div>
              </el-col>
            </el-row>

            <!-- 下步骤条 -->
            <el-row class="flex-align">
              <!--              <el-col :span="2"> </el-col>-->

              <!--              <el-col :span="3" class="flex-align flex-height"> </el-col>-->


              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '70'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <div style=" width: 100%;  position: relative;    height: 5px;">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "
                          :style="userForm.status >= '70'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '60'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <div style=" width: 100%;  position: relative;    height: 5px;">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom "
                          :style="userForm.status >= '60'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '50'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <div style=" width: 100%;  position: relative;    height: 5px;">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom background-color-ccc"
                          :style="userForm.status >= '50'  ? 'background-color: orange' : 'background-color: #ccc' "
                  ></div>
                </div>
              </el-col>

              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '50'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>


            </el-row>

            <!-- 下标题 -->
            <el-row
                    style=" display: flex;max-height: 60px;"
            >
              <!--              <el-col :span="2"> </el-col>-->

              <!--              <el-col style="text-align: center;" :span="3"></el-col>-->
              <!--              <el-col :span="3">-->
              <!--                <div class="flex-div">-->
              <!--                  <div-->
              <!--                    class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align"-->
              <!--                  >-->
              <!--                    <p class="span-font-size " :style="userForm.status >= '80'  ? 'color: black;font-weight: bold;' : 'color: #ccc' " >发运</p>-->
              <!--                    <p class="span-font-size " :style="userForm.status >= '80'  ? 'color: black;font-weight: bold;' : 'color: #ccc' " >Dispatch</p>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </el-col>-->

              <!--              <el-col style="text-align: center;" :span="4"></el-col>-->

              <el-col :span="3" >
                <!--                  <div class="center-line-col" >-->
                <!--                      <div class="vertical-line"   :style="userForm.status >= '50'  ? 'border-left: 5px solid orange;' : 'border-left: 5px solid #ccc;' " ></div>-->
                <!--                  </div>-->
                <!--                <div class="flex-div">-->
                <!--                  <div-->
                <!--                    class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align"-->
                <!--                  >-->
                <!--                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">上传图片</p>-->
                <!--                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;white-space: nowrap;left: -16px;position: absolute;' : 'color: #ccc;white-space: nowrap;left: -16px;position: absolute;' ">Upload Product Image</p>-->

                <!--                  </div>-->
                <!--                </div>-->
                <!--                  position: absolute;left: -13px;'-->
                <!--                  position: absolute;left: -13px;text-align: center;-->
                <el-row>
                  <el-col :span="12">
                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;text-align: center;' ">上传</p>
                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;position: absolute;left: -12px;' : 'color: #ccc;position: absolute;left: -12px;' ">Upload </p>
                  </el-col>

                  <el-col  class="center-line-col" :span="2">
                    <div class="vertical-line"   :style="userForm.status >= '80'  ? 'border-left: 5px solid orange;' : 'border-left: 5px solid #ccc;' " ></div>
                  </el-col>

                  <el-col  :span="2">
                    &nbsp;
                  </el-col>

                  <el-col :span="8">
                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">图片</p>
                    <p class="span-font-size " :style="userForm.status >= '70'  ? 'color: black;font-weight: bold;' : 'color: #ccc;' ">Product Image</p>
                  </el-col>
                </el-row>



              </el-col>

              <el-col style="text-align: center;" :span="3"></el-col>

              <el-col :span="4">
                <el-row>
                  <el-col :span="3">&nbsp;</el-col>
                  <!--                      <el-col :span="20">-->
                  <!--                          <div class="flex-div">-->
                  <!--                              <div-->
                  <!--                                      class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align"-->
                  <!--                              >-->
                  <!--                                  <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">烘干和湿度测量</p>-->
                  <!--                                  <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;position: absolute;left: -7px;white-space: nowrap;top: 15px;' : 'color: #ccc;position: absolute;left: -7px;white-space: nowrap;top: 15px;' ">Drying and Humidity</p>-->
                  <!--                                  <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;position: absolute;top: 30px;left: -7px;' : 'color: #ccc;position: absolute;top: 30px;left: -7px;' "> Measurement</p>-->
                  <!--                              </div>-->
                  <!--                          </div>-->


                  <el-col :span="21" style="text-align: right;">
                    <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">烘干和湿度测量</p>
                    <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">Drying and Humidity</p>
                    <p class="span-font-size " :style="userForm.status >= '60'  ? 'color: black;font-weight: bold;' : 'color: #ccc;' "> Measurement</p>
                  </el-col>
                  <!--                      <el-col :span="2"></el-col>-->

                </el-row>


              </el-col>

              <el-col style="text-align: center;" :span="3"></el-col>

              <el-col :span="4">
                <!--                <div class="flex-div">-->
                <!--                  <div-->
                <!--                    class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align"-->
                <!--                  >-->
                <!--                    <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">洗涤</p>-->
                <!--                    <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">Washing</p>-->
                <!--                  </div>-->
                <!--                </div>-->
                <el-row>
                  <el-col :span="5">&nbsp;</el-col>
                  <el-col :span="19" style="text-align: center;">
                    <div>
                      <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">洗涤</p>
                      <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;' : 'color: #ccc' ">Washing</p>
                    </div>
                  </el-col >

                </el-row>

              </el-col>

              <el-col style="text-align: center;" :span="3"></el-col>

              <el-col :span="4">
                <!--                <div class="flex-div">-->
                <!--                  <div-->
                <!--                    class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align"-->
                <!--                  >-->
                <!--                    <p class="span-font-size" :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">洗护前质检</p>-->
                <!--                    <p class="span-font-size" :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;white-space: nowrap;position: absolute;left: -10px;top: 15px;' : 'color: #ccc;white-space: nowrap;position: absolute;left: -10px;top: 15px;' ">Quality Check<p/>-->
                <!--                    <p class="span-font-size" :style="userForm.status >= '40'  ? 'color: black;font-weight: bold;white-space: nowrap;position: absolute;left: -17px;top: 28px;' : 'color: #ccc;white-space: nowrap;position: absolute;left: -17px;top: 28px;' ">before Washing<p/>-->
                <!--                  </div>-->
                <!--                </div>-->
                <el-row>
                  <el-col :span="4">&nbsp;</el-col>
                  <el-col :span="20" style="text-align: center;">
                    <div>
                      <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">洗护前质检</p>
                      <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">Quality Check</p>
                      <p class="span-font-size " :style="userForm.status >= '50'  ? 'color: black;font-weight: bold;;white-space: nowrap;' : 'color: #ccc;white-space: nowrap;' ">before Washing</p>
                    </div>
                  </el-col >
                </el-row>
              </el-col>

            </el-row>

            <!-- 竖线 -->
            <el-row class="flex-position-left">
              <el-col :span="3">
                <div class="flex-div flex-border-radius">
                  <div
                          class="flex-position flex-position-top flex-position-left  flex-position-right flex-position-bottom  flex-border-radius "
                          :style="userForm.status >= '80'  ? 'border: 8px solid orange' : 'border: 8px solid #ccc' "
                  ></div>
                </div>
              </el-col>
            </el-row>

            <!-- 竖线 -->
            <el-row class="flex-position-left">
              <el-col :span="3">
                <div class="flex-div">
                  <div class="flex-position flex-position-left  flex-position-right flex-position-top flex-text-align">
                    <p class="span-font-size " :style="userForm.status >= '80'  ? 'color: black;font-weight: bold;' : 'color: #ccc' " >发运</p>
                    <p class="span-font-size " :style="userForm.status >= '80'  ? 'color: black;font-weight: bold;' : 'color: #ccc' " >Dispatch</p>
                  </div>
                </div>
              </el-col>
            </el-row>


          </el-col>

          <!--          <el-col :xs="1" :sm="2" :lg="3"></el-col>-->
        </el-row>

        <el-row
                style="display: flex;justify-content: center;align-items: center;margin-top: 20px;"
        >
          <!--          <el-col :xs="1" :sm="2" :lg="3"></el-col>-->
          <el-col

                  style="background-color: #ccc;font-weight: bold;padding-left: 10px;"
          >

            明细：
            <span style="display: flex">Details</span>


          </el-col>
          <!--          <el-col :xs="1" :sm="2" :lg="3"></el-col>-->
        </el-row>




        <el-row
                style="display: flex;justify-content: center;align-items: flex-start;"
        >
          <!--          <el-col :xs="1" :sm="3" :lg="3"></el-col>-->
          <el-col :xs="7" :sm="6" :lg="6">
            <span
                    style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >
                {{detailList[0]}} </span
            >
          </el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            > {{detailList[3]}}</span
            >
          </el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            > {{detailList[6]}}</span
            >
          </el-col>
          <!--          <el-col :xs="1" :sm="3" :lg="3"></el-col>-->
        </el-row>



        <el-row
                style="display: flex;justify-content: center;align-items: flex-start;"
        >
          <!--          <el-col :xs="1" :sm="3" :lg="3"></el-col>-->
          <el-col :xs="7" :sm="6" :lg="6">
            <span
                    style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >
             {{detailList[1]}}</span
            >
          </el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >{{detailList[4]}}</span
            >
          </el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >{{detailList[7]}}</span
            >
          </el-col>
          <!--          <el-col :xs="1" :sm="3" :lg="3"></el-col>-->
        </el-row>

        <el-row
                style="display: flex;justify-content: center;align-items: flex-start;"
        >
          <el-col :xs="1" :sm="3" :lg="3"></el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span
                    style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >
             {{detailList[2]}}</span
            >
          </el-col>
          <el-col :xs="7" :sm="6" :lg="6">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >{{detailList[5]}}</span
            >
          </el-col>
          <el-col :xs="8" :sm="9" :lg="9">
            <span style="display: block;padding: 5px 4px;word-wrap: break-word;"
            >{{detailList[8]}}</span
            >
          </el-col>
          <!--          <el-col :xs="1" :sm="3" :lg="3"></el-col>-->
        </el-row>

        <el-row style="display: flex;margin: 20px 0px 20px 0px;justify-content: center;">
          <el-col :span="6" style="text-align: center;">

            <a-button @click="returnHome" style="background-color: #dae3f3;width: 100px;height: 40px;padding: 0px 0px;">
              <div style="display: flex;flex-direction: column;justify-content: center;line-height: 15px;">
                <span style="padding-top: 4px;">返回</span>
                <span style="padding-bottom: 2px;">Back to Menu</span>
              </div>
            </a-button>


          </el-col>
          <!-- <el-col :span="6" style="flex:1;"> </el-col>
          <el-col :span="6">
            <el-button style="margin-right: 10px;" @click="clearBtn"
              >保存</el-button
            >
          </el-col> -->
        </el-row>
      </el-footer>
    </el-container>

    <barcode-scan @getScanResult="getResult" @isHiddenScanBtn="isHiddenScanBtn" :show="isShown" />

  </div>
</template>

<script>
  import ajax from "../../api/ajax";
  import api from "../../api/url";
  import { mapState } from "vuex";
  import axios from "axios";
  import cookie from "../../api/cookie";
  import barcodeScan from "./barcodeScan.vue";


  export default {
    components: {
      barcodeScan
    },
    name: "moose_washing",
    data() {
      return {
        isHiddenScan:true,
        userForm: {
          userName: "",
          phone: "",
          address: "",
          trackingNumber: "",
          status:""
        },
        isLoading: false,
        uploadData: {
          trackingNo: "",
        },
        uploadData2: {
          trackingNo: "",
        },
        picFileList: [],
        dialogVisible: false,
        dialogImageUrl: "",
        dialogVisible2: false,
        dialogImageUrl2: "",
        picFileList2: [],
        detailList: [],
        stepStatus: "",
        active: 0,
        status: "",
        detailList:[],
        isShown : false
      };
    },
    methods: {
      isHiddenScanBtn(){
        this.isHiddenScan = false
      },
      handleBarcode(){
        this.isShown = true;
      },
      getResult(val){
        this.userForm.trackingNumber =  val;
        this.isShown = false;
      },
      returnHome() {
        this.$router.push({ path: "/moose/home" });
      },
      queryOrder(){

        if(this.userForm.trackingNumber  == null || this.userForm.trackingNumber.length == 0){
          this.$message.warning("快递单号不能为空");
          return
        }

        this.isLoading = true;
        ajax.get(api.MOOSEQUERY, { trackingNumber: this.userForm.trackingNumber }).then(res => {
          this.isLoading = false
          if (res.code == 200) {
            let data = res.data ;
            this.userForm.userName = data.userName
            this.userForm.phone = data.phone
            this.userForm.address = data.address
            this.userForm.status = data.status
            this.detailList = data.detailList



            this. picFileList=[]
            data.beforeWashPhotos.forEach(item => {
              this. picFileList.push({url: item,status:"ready" })
            });

            this. picFileList2 = []
            data.afterWashPhotos.forEach(item => {
              this. picFileList2.push({url: item ,status:"ready"})
            });




          } else {
            this.$message.warning(res.msg);
          }
        });


      },



      clearBtn() {},

      next() {
        if (this.active++ > 2) this.active = 0;
      },
      beforeUploadPic2(file, fileList) {
        this.picFileList2 = fileList;
      },
      beforeUploadPic(file, fileList) {
        this.picFileList = fileList;
      },
      uploadPicSuccess2(response, file, fileList) {
        if (response.code == 200) {
          this.$message({ message: "上传成功!", type: "success" });
        } else {
          this.$message.error(response.msg);
        }
        this.loading = false;
        this.$refs.uploadPicRef.clearFiles();
      },
      uploadPicSuccess(response, file, fileList) {
        if (response.code == 200) {
          this.$message({ message: "上传成功!", type: "success" });
        } else {
          this.$message.error(response.msg);
        }
        this.loading = false;
        this.$refs.uploadPicRef.clearFiles();
      },
      removePic(file, fileList) {
        this.picFileList = fileList;
      },
      removePic2(file, fileList) {
        this.picFileList2 = fileList;
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePictureCardPreview2(file) {
        this.dialogImageUrl2 = file.url;
        this.dialogVisible2 = true;
      },
      uploadPicHandle() {
        if (this.trackingNo.length == 0) {
          this.$message.error("快递单号不能为空!");
          return;
        }
        if (this.picFileList.length == 0) {
          this.$message.error("请先添加图片!");
          return;
        }
        this.uploadData.trackingNo = this.trackingNo;
        this.loading = true;
        this.$refs.uploadPicRef.submit();
      },
    },
  };
</script>

<style scoped>
  /* .hidden-sm-only {
   padding: 0;
  } */


  .required {
    color: red;
    margin-right: 5px; /* 可选：增加间距 */
  }

  .background-color-ccc {
    background-color: #ccc;
  }
  .border-ccc {
    border: 10px solid #ccc;
  }
  .flex-text-align {
    text-align: center;
  }
  .flex-position-left {
    left: 0;
  }

  .flex-position-bottom {
    bottom: 0;
  }

  .flex-position-right {
    right: 0;
  }

  .flex-position-top {
    top: 0;
  }

  .flex-position {
    position: absolute;
  }

  .flex-border-radius {
    border-radius: 50%;
  }

  .flex-div {
    width: 100%;
    padding-top: 100%;
    position: relative;
  }

  .flex-height {
    height: 100%;
  }

  .flex-align {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .span-font-size {
    font-size: 10px; /* Adjust this value based on your design requirements */
    /* color: #ccc;    */

  }
  .ccc-color {
    color: #ccc;
  }

  .center-line-col {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    height: 60px; /* 确保列的高度足够 */
  }

  .vertical-line {
    /* 竖线样式 */
    height: 100%; /* 竖线高度填充父元素 */
    width: 1px; /* 竖线宽度 */
  }

  .font-weight-bold {
    font-weight: bold;
  }
  .container >>> .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-weight: normal !important;
  }
  .container {
    height: 100%;
    padding: 20px;
  }
  .upload-demo >>>  .el-upload-list__item-actions .el-upload-list__item-delete {
    display: none !important;
  }
  .form-item-spacing {
    margin-bottom: 5px; /* 根据需要调整距离 */
  }
  .label {
    margin-right: 10px;
  }

  .upload-demo >>> .el-upload__input {
    display: none; /* 隐藏文件选择按钮 */
  }

  .upload-demo >>> .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 120px;
    height: 120px;
    margin: none;
    display: inline-block;
  }

  .upload-demo >>> .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    line-height: 38px;
    vertical-align: top;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: none;
  }

  .upload-demo >>> ul {
    margin-top: 15px;
  }
  .upload-demo >>> .el-upload-list--picture-card {
    display: inline-block !important;
  }

  .upload-demo >>> .el-upload--picture-card i {
    font-size: 20px !important;
    margin: 10px !important;
  }

  #interactive.viewport {
    width: 640px;
    height: 480px;
  }

  #interactive.viewport canvas,
  #interactive.viewport video {
    float: left;
    width: 640px;
    height: 480px;
  }

  #interactive.viewport canvas.drawingBuffer,
  #interactive.viewport video.drawingBuffer {
    margin-left: -640px;
  }
</style>
